__turbopack_context__.v({
  "acheiverrank": "current-affairs-module__v2rUsq__acheiverrank",
  "bg": "current-affairs-module__v2rUsq__bg",
  "box": "current-affairs-module__v2rUsq__box",
  "btntext": "current-affairs-module__v2rUsq__btntext",
  "content": "current-affairs-module__v2rUsq__content",
  "normalbutton2": "current-affairs-module__v2rUsq__normalbutton2",
  "pagemaintitle": "current-affairs-module__v2rUsq__pagemaintitle",
  "redtext": "current-affairs-module__v2rUsq__redtext",
  "sectiontitle": "current-affairs-module__v2rUsq__sectiontitle",
});
